import { fetchCentralApi } from '../utils/helpers';
import constants from '../constants';

const {
  FETCH_VAULTERS_REQUEST,
  FETCH_VAULTERS_SUCCESS,
  FETCH_VAULTERS_FAILURE,
  ADD_VAULTER_REQUEST,
  ADD_VAULTER_FAILURE,
  ADD_VAULTER_SUCCESS,
} = constants;

/**
 * Fetch vaulters
 */
export const fetchVaultersSuccess = data => ({
  type: FETCH_VAULTERS_SUCCESS,
  payload: {
    vaulters: data.vaulters,
  },
});

export const fetchVaultersFailure = () => ({
  type: FETCH_VAULTERS_FAILURE,
});

export const fetchVaultersRequest = () => ({
  type: FETCH_VAULTERS_REQUEST,
});

export const fetchVaulters = (nation, token) => dispatch => {
  dispatch(fetchVaultersRequest());

  return fetchCentralApi({
    path: `/vaulters?nation=${nation}`,
    method: 'get',
    token,
    dispatch,
    cb: fetchVaultersSuccess,
    fb: fetchVaultersFailure,
  });
};

/**
 * Add vaulter
 */
export const addVaulterSuccess = (resolve, data) => dispatch => {
  resolve();

  dispatch({
    type: ADD_VAULTER_SUCCESS,
    payload: {
      vaulter: data.vaulter,
    },
  });
};

export const addVaulterFailure = reject => dispatch => {
  reject();

  dispatch({
    type: ADD_VAULTER_FAILURE,
  });
};

export const addVaulterRequest = () => ({
  type: ADD_VAULTER_REQUEST,
});

export const addVaulter = (body, token) => dispatch => {
  dispatch(addVaulterRequest());

  return new Promise((resolve, reject) => {
    fetchCentralApi({
      path: '/vaulters',
      method: 'post',
      token,
      body: JSON.stringify(body),
      dispatch,
      cb: addVaulterSuccess.bind(this, resolve),
      fb: addVaulterFailure.bind(this, reject),
    });
  });
};



// WEBPACK FOOTER //
// ./src/actions/vaulters.js